import {
  DEMORA,
  DEMORA_FAIL,
  DEMORA_RESET,
  DEMORA_SUCCESS,
} from "../ActionTypes";
import demoraInitialState from "../initialState/demoraInitialState";

const demora = (state, { payload, type }) => {
  switch (type) {
    case DEMORA:
      return {
        ...state,
        demora: {
          ...state.demora,
          loading: true,
          error: false,
          data: null,
        },
      };
    case DEMORA_SUCCESS:
      return {
        ...state,
        demora: {
          ...state.demora,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case DEMORA_FAIL:
      return {
        ...state,
        demora: {
          ...state.demora,
          loading: false,
          error: payload,
          data: null,
        },
      };
    case DEMORA_RESET:
      return demoraInitialState;

    default:
      return state;
  }
};

export default demora;
